import React from 'react';
import { useBoolean } from '@chakra-ui/react';
import { ToggleShowPasswordButton } from '../../PasswordReset/ToggleShowPasswordButton';
import { InputField, InputFieldProps } from '../ChakraInputField';

export const PasswordInput = React.forwardRef<
  HTMLInputElement,
  InputFieldProps
>(({ className, ...props }, ref) => {
  const [showPassword, { toggle: toggleShowPassword }] = useBoolean();

  return (
    <InputField
      ref={ref}
      type={showPassword ? 'text' : 'password'}
      rightElement={
        <ToggleShowPasswordButton
          passwordVisible={showPassword}
          onClick={toggleShowPassword}
        />
      }
      letterSpacing="2px"
      data-testid="password"
      errorMessageProps={{ 'data-testid': 'password-error-text' }}
      {...props}
    />
  );
});
